import type { ColumnDef } from "@tanstack/react-table";
import type { ReactNode } from "react";
import { SimpleTable } from "@/core/components/simple-table";
import { Stack } from "@/core/components/ui/stack";
import { useStAdjustmentsSection } from "./st-adjustments-section";
import type { StAdjustmentTechnicianGroup } from "./types";

interface StAdjustmentsRollupTableProps {
  columns: ColumnDef<StAdjustmentTechnicianGroup, unknown>[];
  children: ReactNode;
}

export const StAdjustmentsRollupTable = ({
  columns,
  children,
}: StAdjustmentsRollupTableProps) => {
  const { byTechnician, detailTechnicianId, setDetailTechnicianId } =
    useStAdjustmentsSection();

  return (
    <Stack
      gap="none"
      align="stretch"
      fullWidth
      className="min-h-0 flex-1 overflow-hidden rounded-lg border border-stroke-tertiary bg-surface-primary"
    >
      {children}

      <Stack
        gap="none"
        align="stretch"
        fullWidth
        className="min-h-0 flex-1 overflow-hidden"
      >
        <SimpleTable
          data={byTechnician}
          columns={columns}
          getRowId={(group) => `${group.employee_id ?? "unknown"}`}
          onRowClick={(group) =>
            setDetailTechnicianId(group.employee_id ?? null)
          }
          selectedRowId={
            detailTechnicianId === null ? null : `${detailTechnicianId}`
          }
          className="h-full min-h-0 w-full min-w-0"
          // The four columns declare 3.5 + 20 + 12 + 10 = 45.5rem. This keeps
          // the amount beside its technician when the detail pane is open.
          tableClassName="min-w-[45.5rem]"
          columnPinning={{ left: ["select"] }}
        />
      </Stack>
    </Stack>
  );
};
